import type { TrialType } from '../api/client';

// The user's paywall plan, attached to every event as `plan` so events split by arm and state
// without a ledger join. Set from useCreditsPlan; null while the paywall is hidden.
export type PlanContext = {
  state: 'trial' | 'subscriber' | 'paywalled';
  trial_type: TrialType;
  cohort: string | null;
  days_left: number | null;
  percent_left: number | null;
};

let current: PlanContext | null = null;

export function setPlanContext(context: PlanContext | null): void {
  current = context;
}

export function getPlanContext(): PlanContext | null {
  return current;
}
